import { clsx, type ClassValue } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

/**
 * tailwind-merge, обученный кастомной ЧИСЛОВОЙ шкале размеров шрифта из tailwind.config
 * (`text-11`…`text-26`). По умолчанию tailwind-merge её не знает и принимает `text-14`/
 * `text-18` за `text-{цвет}` (как `text-white`), считая их конфликтом одной группы, — и при
 * слиянии УДАЛЯЕТ цвет. Из-за этого `bg-accent text-white … text-14` терял `text-white`
 * (белый текст на акцентных primary-кнопках/бейдже бренда становился цветом body — почти
 * чёрным). Регистрируем шкалу в группе `font-size`, чтобы размер и цвет не конфликтовали;
 * настоящие конфликты цвета (`text-white text-txt`) по-прежнему резолвятся корректно.
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [
        { text: ['11', '12', '13', '14', '15', '16', '18', '19', '20', '22', '26'] },
      ],
    },
  },
})

/** Слияние Tailwind-классов с разрешением конфликтов (конвенция shadcn/ui). */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
